import * as Phaser from "phaser-ce"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum DefinitionAudio {
    NARRATION_INTRO = "definition-narr-intro.mp3",
    NARRATION_CLICK_NEXT = "definition-narr-click-next.mp3",
    NARRATION_CLICK_ANOTHER_WORD = "definition-narr-click-another-word.mp3",
    NARRATION_CHOOSE_ANSWER = "definition-narr-choose-answer.mp3",
    NARRATION_OUTRO = "definition-narr-outro.mp3",

    WORDS_SMART = "definition-words-smart.mp3",
    LOOK_SMART = "definition-look-smart.mp3",
    FEEL_DUMB = "definition-feel-dumb.mp3",

    WORDS_POPULAR = "definition-words-popular.mp3",
    LOOK_POPULAR = "definition-look-popular.mp3",
    FEEL_UNPOPULAR = "definition-feel-unpopular.mp3",

    WORDS_GOODLOOKING = "definition-words-good-looking.mp3",
    LOOK_GOODLOOKING = "definition-look-good-looking.mp3",
    FEEL_UGLY = "definition-feel-ugly.mp3",

    WORDS_GROWNUP = "definition-words-grown-up.mp3",
    LOOK_GROWNUP = "definition-look-grown-up.mp3",
    FEEL_CHILDISH = "definition-feel-childish.mp3",

    WORDS_EXCITING = "definition-words-exciting.mp3",
    LOOK_EXCITING = "definition-look-exciting.mp3",
    FEEL_BORING = "definition-feel-boring.mp3",

    WORDS_COOL = "definition-words-cool.mp3",
    LOOK_COOL = "definition-look-cool.mp3",
    FEEL_NOTCOOL = "definition-feel-notcool.mp3"
}

export enum DefinitionImages {
    BACKGROUND = "background.png",
    KIDS_SMILE = "kids-smile.png",
    KIDS_FROWN = "kids-frown.png",

    BUBBLE_SMART = "bubble-smart.png",
    BUBBLE_POPULAR = "bubble-popular.png",
    BUBBLE_GOODLOOKING = "bubble-good-looking.png",
    BUBBLE_GROWNUP = "bubble-grown-up.png",
    BUBBLE_EXCITING = "bubble-exciting.png",
    BUBBLE_COOL = "bubble-cool.png",

    DETAIL_SMART = "detail-smart.png",
    DETAIL_POPULAR = "detail-popular.png",
    DETAIL_GOODLOOKING = "detail-good-looking.png",
    DETAIL_GROWNUP = "detail-grown-up.png",
    DETAIL_EXCITING = "detail-exciting.png",
    DETAIL_COOL = "detail-cool.png",

    DETAIL_SMART_NOT = "detail-smart-not.png",
    DETAIL_POPULAR_NOT = "detail-popular-not.png",
    DETAIL_GOODLOOKING_NOT = "detail-good-looking-not.png",
    DETAIL_GROWNUP_NOT = "detail-grown-up-not.png",
    DETAIL_EXCITING_NOT = "detail-exciting-not.png",
    DETAIL_COOL_NOT = "detail-cool-not.png"
}


export function loadAssets(game: Phaser.Game) {

    const load = PhaserUtils.makeLoader(game, "definition")
    
    load.autoLoad({imageEnum: DefinitionImages, audioEnum: DefinitionAudio})
}
